
export default function ({ app, redirect, route, store }) {
  const cookie = app.$cookies.get('locale')
  const langs = process.env.langs.split('|')

  if (route.fullPath === '/' && cookie && cookie !== store.state.i18n.locale && langs.includes(cookie)) {
    return redirect(302, app.switchLocalePath(cookie))
  }
}
